export const moduleId = 'confirmation';
